import { render, staticRenderFns } from "./SubmissionDetailCardstack.vue?vue&type=template&id=5572e5ef"
import script from "./SubmissionDetailCardstack.vue?vue&type=script&lang=js"
export * from "./SubmissionDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports